export const isRelayContainerNotFoundError = (error: unknown) => {
    return isRelayDriverError(error) && (error as any).errorType === "fileNotFoundOrAccessDeniedError"
};

// Type guard for Fluid 2.0: check for errorType and message on any object
const isRelayDriverError = (error: unknown): error is { errorType: string; message: string } => {
    return !!error && typeof error === 'object'
        && 'errorType' in error
        && 'message' in error;
};